'use es6';

import { OrderedMap as ImmutableMap, Record } from 'immutable';
import * as Actions from 'FormsUI/actions/Templates';
import * as RequestStates from 'FormsCommonComponents/lib/RequestState';
const INIT_STATE = new Record({
  templates: new ImmutableMap(),
  requestState: RequestStates.NOT_REQUESTED
})();
function receiveTemplates(state, payload) {
  return state.set('templates', new ImmutableMap(payload.map(template => [template.name, template.definition])));
}
function setRequestState(state, newRequestState) {
  return state.set('requestState', newRequestState);
}
export function templates(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_TEMPLATES:
      return setRequestState(state, RequestStates.REQUESTED);
    case Actions.RECEIVE_TEMPLATES:
      return receiveTemplates(state, action.payload);
    case Actions.SUCCEEDED_GETTING_TEMPLATES:
      return setRequestState(state, RequestStates.SUCCEEDED);
    case Actions.FAILED_GETTING_TEMPLATES:
      return setRequestState(state, RequestStates.FAILED);
    default:
      return state;
  }
}